var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    class: { "faded-card": _vm.showCardFaded },
    scopedSlots: _vm._u(
      [
        {
          key: "body",
          fn: function () {
            return [
              _vm.editing
                ? _c(
                    "div",
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.descriptionText,
                            expression: "descriptionText",
                          },
                        ],
                        ref: "textarea",
                        staticClass:
                          "w-100 editable-follow-up rich-text-editor--reset p-0",
                        style: "height: " + _vm.height + "px",
                        attrs: { id: "edit-textarea" },
                        domProps: { value: _vm.descriptionText },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.descriptionText = $event.target.value
                            },
                            _vm.handleInput,
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "d-none",
                          attrs: { for: "edit-textarea" },
                        },
                        [_vm._v(_vm._s(_vm.$t("global.words.edit")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "pb-2" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-row",
                                { staticClass: "justify-content-end" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "d-none",
                                      attrs: { for: "edit-text-id" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("global.words.edit"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "d-none",
                                      attrs: { for: "foreground-color" },
                                    },
                                    [_vm._v("Color Picker")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "d-none",
                                      attrs: { for: "background-color" },
                                    },
                                    [_vm._v("Color Picker")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { xxl: "", cols: "12" } },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "d-flex align-items-end justify-content-start",
                                              attrs: {
                                                xxl: "6",
                                                xl: "6",
                                                lg: "12",
                                                sm: "4",
                                                cols: "12",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "bold text-regular-gray tiny text-uppercase mr-4 mt-0",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "client-profile.messages.assignedTo"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("assignee-select", {
                                                ref: "notifySelect",
                                                staticClass: "w-100",
                                                attrs: {
                                                  id: "follow-up-tab-assignees",
                                                  "client-profile-id":
                                                    _vm.clientProfileId,
                                                  assignees: _vm.assignees,
                                                  "inline-edit": true,
                                                  "keep-editing": _vm.editing,
                                                  owner: _vm.owner,
                                                  "preload-collaborators": false,
                                                  "time-line-item-card": "",
                                                },
                                                on: {
                                                  change:
                                                    _vm.handleAssigneeChange,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "d-none",
                                                  attrs: {
                                                    for: "select-assignee",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.words.label"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "d-flex align-items-end",
                                              attrs: {
                                                xxl: "3",
                                                xl: "3",
                                                lg: "6",
                                                sm: "4",
                                                cols: "12",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-group-material followup-scheduled-date-wrapper m-0",
                                                },
                                                [
                                                  _c(
                                                    "material-input",
                                                    {
                                                      staticClass: "mb-0",
                                                      model: {
                                                        value:
                                                          _vm.followUpScheduledDate,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.followUpScheduledDate =
                                                            $$v
                                                        },
                                                        expression:
                                                          "followUpScheduledDate",
                                                      },
                                                    },
                                                    [
                                                      _c("datepicker-input", {
                                                        attrs: {
                                                          id: "date-picker",
                                                          name: "closing-date",
                                                          "show-calendar": false,
                                                          placeholder:
                                                            "YYYY-MM-DD",
                                                          "future-date": "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.followUpScheduledDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.followUpScheduledDate =
                                                              $$v
                                                          },
                                                          expression:
                                                            "followUpScheduledDate",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass: "d-none",
                                                          attrs: {
                                                            for: "date-picker",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "global.words.date"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "d-flex align-items-end",
                                              attrs: {
                                                xxl: "3",
                                                xl: "3",
                                                lg: "6",
                                                sm: "4",
                                                cols: "12",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-group-material followup-scheduled-date-wrapper m-0 vertical-center",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "bold text-regular-gray tiny text-uppercase mr-4 mt-0",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "global.words.at"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-container form-group-material form-group-material-no-label position-relative fe-dp",
                                                    },
                                                    [
                                                      _c("time-input", {
                                                        attrs: {
                                                          id: "time-input",
                                                          "default-value":
                                                            _vm.followUpNotificationTime,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.followUpScheduledTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.followUpScheduledTime =
                                                              $$v
                                                          },
                                                          expression:
                                                            "followUpScheduledTime",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass: "d-none",
                                                          attrs: {
                                                            for: "time-input",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "global.words.time"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar",
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mt-xl-0 mt-4 pt-xl-0 pt-2",
                                      attrs: {
                                        xl: "auto",
                                        lg: "6",
                                        sm: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-primary float-right btn-xs add-list mt-3",
                                          attrs: {
                                            type: "button",
                                            disabled: !_vm.canSave,
                                          },
                                          on: { click: _vm.handleSubmit },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "global.actions.saveChanges"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("html-iframe-preview", {
                    staticClass: "follow-up-description p-0",
                    attrs: {
                      content: _vm.descriptionText,
                      "break-content-words": "",
                    },
                    on: {
                      dblclick: function ($event) {
                        $event.preventDefault()
                        return _vm.editFollowUp.apply(null, arguments)
                      },
                    },
                  }),
            ]
          },
          proxy: true,
        },
        !_vm.editing
          ? {
              key: "footer",
              fn: function () {
                return [
                  _c("timeline-card-footer", {
                    attrs: { pinned: _vm.pinned },
                    on: {
                      pinned: function ($event) {
                        return _vm.handlePin(
                          _vm.id,
                          _vm.activityType,
                          _vm.pinned
                        )
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "left",
                          fn: function () {
                            return [
                              _c(
                                "b-col",
                                {
                                  staticClass: "vertical-center mb-md-0 mb-2",
                                  attrs: { cols: "12", md: "auto" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "vertical-center" },
                                    [
                                      _c(
                                        "profile-avatar",
                                        _vm._b(
                                          {
                                            staticClass:
                                              "client-profile-owner-avatar mr-2",
                                            attrs: {
                                              "avatar-options": {
                                                inline: true,
                                              },
                                            },
                                          },
                                          "profile-avatar",
                                          Object.assign({}, _vm.creator),
                                          false
                                        )
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "mr-1" }, [
                                        _vm._v(_vm._s(_vm.name)),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("i18n", {
                                    staticClass: "text-lowercase",
                                    attrs: {
                                      path: "global.actions.hasCreatedAn",
                                      tag: "span",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-secondary bold",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$tc(
                                                          "global.words.activity",
                                                          1
                                                        )
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3973597571
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "px-2" }, [
                                    _vm._v("-"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm._f("momentLocal")(
                                            _vm.createdAt,
                                            "MMM. DD, YYYY"
                                          )
                                        ) +
                                        " @\n            " +
                                        _vm._s(
                                          _vm._f("momentLocal")(
                                            _vm.createdAt,
                                            "LT"
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.latestUpdate
                                    ? [
                                        _c("span", { staticClass: "px-2" }, [
                                          _vm._v("|"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "profile-avatar",
                                          _vm._b(
                                            {
                                              staticClass:
                                                "client-profile-owner-avatar mr-2",
                                              attrs: {
                                                "avatar-options": {
                                                  inline: true,
                                                },
                                              },
                                            },
                                            "profile-avatar",
                                            _vm.latestUpdate.user,
                                            false
                                          )
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "mr-1" }, [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$options.filters.nameFormat(
                                                  _vm.latestUpdate.user
                                                    .givenName,
                                                  _vm.latestUpdate.user
                                                    .familyName
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t("global.words.updated")
                                              ) +
                                              "\n              "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-secondary bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$tc(
                                                      "global.words.activity",
                                                      1
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "px-2" }, [
                                          _vm._v("-"),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm._f("momentLocal")(
                                                  _vm.latestUpdate.timestamp,
                                                  "MMM. DD, YYYY"
                                                )
                                              ) +
                                              " @\n              " +
                                              _vm._s(
                                                _vm._f("momentLocal")(
                                                  _vm.latestUpdate.timestamp,
                                                  "LT"
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "vertical-center ml-3",
                                  attrs: { cols: "12", md: "auto" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pretty p-icon p-smooth mx-0",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "valid follow-up-complete",
                                        attrs: {
                                          id: _vm.labelValue,
                                          "follow-up-id": _vm.id,
                                          type: "checkbox",
                                        },
                                        domProps: { checked: _vm.isComplete },
                                        on: { change: _vm.completeFollowUp },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "state p-primary p-success",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon fa fa-check",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "text-light-gray clickable",
                                              attrs: { for: _vm.labelValue },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.words.complete"
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "right",
                          fn: function () {
                            return [
                              _c(
                                "b-col",
                                {
                                  staticClass: "vertical-center",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "bold mr-1 mt-0" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("global.words.due")) + ":"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      ref: "scheduledDate",
                                      staticClass: "followup-scheduled-date",
                                      class: _vm.scheduledCssClass,
                                      on: {
                                        dblclick: function ($event) {
                                          $event.preventDefault()
                                          return _vm.editScheduledDate.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("momentLocal")(
                                            _vm.followUpScheduledDate,
                                            "MMM. DD, YYYY"
                                          )
                                        ) +
                                          " @\n            " +
                                          _vm._s(_vm.formattedScheduledTime)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mx-3" },
                                    [
                                      _c("assignee-select", {
                                        staticClass: "w-100",
                                        attrs: {
                                          "client-profile-id":
                                            _vm.clientProfileId,
                                          assignees: _vm.assignees,
                                          "inline-edit": true,
                                          owner: _vm.owner,
                                          board: _vm.boardId,
                                          "preload-collaborators": false,
                                          "time-line-item-card": "",
                                          "avatar-container-class": "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex flex-row align-items-center justify-content-end justify-content-md-start",
                                  attrs: { col: "", md: "auto" },
                                },
                                [
                                  _c("div", { staticClass: "dropleft" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "grey-text text-darken-4 clickable vertical-center",
                                        attrs: { "data-toggle": "dropdown" },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("more_vert")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "dropdown-menu" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item clickable text-primary edit-follow-up",
                                            attrs: {
                                              "data-follow-up-id": _vm.id,
                                            },
                                            on: { click: _vm.editFollowUp },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "client-profile.actions.editActivity"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "dropdown-divider",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "inline-prompt",
                                              {
                                                attrs: {
                                                  placement: "left",
                                                  "confirmation-text": _vm.$t(
                                                    "client-profile.messages.deleteConfirmation",
                                                    {
                                                      item: _vm.$tc(
                                                        "global.words.activity",
                                                        1
                                                      ),
                                                    }
                                                  ),
                                                },
                                                on: {
                                                  accept: _vm.handleDelete,
                                                },
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item clickable text-danger btn-danger remove-followup",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "client-profile.actions.deleteActivity"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3605824142
                    ),
                  }),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }